const ACCESS_KEY = 'mute_access_token';
const REFRESH_KEY = 'mute_refresh_token';
let refreshPromise = null;
export function getAccessToken() {
    return localStorage.getItem(ACCESS_KEY);
}
export function getRefreshToken() {
    return localStorage.getItem(REFRESH_KEY);
}
export function setTokens(access, refresh) {
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
}
export function clearTokens() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem('mute_intro_seen');
}
async function refreshAccessToken() {
    const refreshToken = getRefreshToken();
    if (!refreshToken)
        throw new Error('No refresh token');
    const res = await fetch('/api/auth/refresh', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken }),
    });
    if (!res.ok) {
        clearTokens();
        throw new Error('Refresh failed');
    }
    const data = await res.json();
    setTokens(data.accessToken, data.refreshToken);
    return data.accessToken;
}
export async function api(url, options = {}) {
    const token = getAccessToken();
    const headers = new Headers(options.headers);
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    // Don't set Content-Type for FormData (browser sets boundary)
    if (!(options.body instanceof FormData) && !headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json');
    }
    const res = await fetch(url, { ...options, headers });
    if (res.status === 401 && token) {
        // Try refresh once (singleton to prevent race conditions)
        if (!refreshPromise) {
            refreshPromise = refreshAccessToken().finally(() => {
                refreshPromise = null;
            });
        }
        try {
            const newToken = await refreshPromise;
            headers.set('Authorization', `Bearer ${newToken}`);
            const retryRes = await fetch(url, { ...options, headers });
            if (!retryRes.ok)
                throw new ApiError(retryRes.status, await retryRes.text());
            return retryRes.json();
        }
        catch {
            clearTokens();
            window.location.href = '/';
            throw new Error('Session expired');
        }
    }
    if (!res.ok) {
        throw new ApiError(res.status, await res.text());
    }
    // Handle 204 No Content
    if (res.status === 204)
        return undefined;
    return res.json();
}
export class ApiError extends Error {
    constructor(status, body) {
        super(`API Error ${status}: ${body}`);
        this.status = status;
        this.body = body;
    }
}
